import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-management"
  }, [_vm._m(0), _c('a-card', [_c('div', {
    staticClass: "search-form"
  }, [_c('a-form', {
    attrs: {
      "layout": "inline",
      "form": _vm.searchForm
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "任务ID"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入任务ID"
    },
    model: {
      value: _vm.searchForm.taskId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "taskId", $$v);
      },
      expression: "searchForm.taskId"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "申请流水"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入申请流水"
    },
    model: {
      value: _vm.searchForm.processInstanceId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "processInstanceId", $$v);
      },
      expression: "searchForm.processInstanceId"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "会议标题"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入会议标题"
    },
    model: {
      value: _vm.searchForm.meetingName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "meetingName", $$v);
      },
      expression: "searchForm.meetingName"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "办理时间"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "format": "YYYY-MM-DD",
      "placeholder": "开始时间,结束时间"
    },
    model: {
      value: _vm.searchForm.handleTime,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "handleTime", $$v);
      },
      expression: "searchForm.handleTime"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "办理状态"
    }
  }, [_c('a-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择办理状态",
      "allowClear": ""
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "PENDING"
    }
  }, [_vm._v("待处理")]), _c('a-select-option', {
    attrs: {
      "value": "IN_PROGRESS"
    }
  }, [_vm._v("处理中")]), _c('a-select-option', {
    attrs: {
      "value": "COMPLETED"
    }
  }, [_vm._v("已完成")])], 1)], 1), _c('a-form-item', [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _c('a-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.taskList,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "row-key": "taskId"
    },
    scopedSlots: _vm._u([{
      key: "taskId",
      fn: function fn(text) {
        return [_c('a-tooltip', {
          attrs: {
            "title": text,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "ellipsis-text"
        }, [_vm._v(_vm._s(text))])])];
      }
    }, {
      key: "processInstanceId",
      fn: function fn(text) {
        return [_c('a-tooltip', {
          attrs: {
            "title": text,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "ellipsis-text"
        }, [_vm._v(_vm._s(text))])])];
      }
    }, {
      key: "status",
      fn: function fn(text) {
        return [_c('a-tag', {
          attrs: {
            "color": _vm.getStatusColor(text)
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(text)))])];
      }
    }, {
      key: "action",
      fn: function fn(record) {
        return [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewDetail(record);
            }
          }
        }, [_vm._v("查看")])];
      }
    }])
  })], 1), _c('a-modal', {
    attrs: {
      "title": "任务详情",
      "visible": _vm.detailVisible,
      "width": 1200,
      "footer": ""
    },
    on: {
      "cancel": function cancel($event) {
        _vm.detailVisible = false;
      }
    }
  }, [_c('MeetingDetail', {
    attrs: {
      "id": _vm.selectedReservationId
    }
  })], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("任务管理")]), _c('span', {
    staticClass: "tip"
  }, [_vm._v("查询和管理会议预约任务记录")])]);
}];
export { render, staticRenderFns };